exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn-right {\n  float: right;\n}\n\n.btn-mid {\n  margin-left: 100px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /home/runner/_work/monorepo/monorepo/admin-portal-old/node_modules/css-loader?{"sourceMap":false,"importLoaders":1}!/home/runner/_work/monorepo/monorepo/admin-portal-old/node_modules/postcss-loader/lib?{"ident":"postcss","sourceMap":false}!/home/runner/_work/monorepo/monorepo/admin-portal-old/src/forms.css
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"importLoaders":1}!../../../../postcss-loader/lib/index.js?{"ident":"postcss","sourceMap":false}!../../../../../src/forms.css
// module chunks = styles